import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import fetch from "logic/rest/FetchProvider";
import UserNotification from "util/UserNotification";
const TELEMETRY_SETTINGS_QUERY_KEY = ["telemetry", "settings"];
const settingsUrl = () => qualifyUrl(ApiRoutes.TelemetryApiController.setting().url);
export const fetchTelemetrySettings = () => fetch("GET", settingsUrl());
export const updateTelemetrySettings = (settings) => fetch("PUT", settingsUrl(), settings);
const useTelemetrySettings = (options) => useQuery({
  queryKey: TELEMETRY_SETTINGS_QUERY_KEY,
  queryFn: fetchTelemetrySettings,
  ...options
});
export const useUpdateTelemetrySettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateTelemetrySettings,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TELEMETRY_SETTINGS_QUERY_KEY }),
    onError: (error) => {
      UserNotification.error(`Update failed: ${error}`, "Could not update telemetry settings.");
    }
  });
};
export default useTelemetrySettings;
